import { useEffect } from 'react';

function useSeoMetadata(seo) {
    useEffect(() => {
        if (!seo) {
            return;
        }

        document.title = seo.title;

        const description = document.querySelector('meta[name="description"]');

        if (description) {
            description.setAttribute('content', seo.description);
        }
    }, [seo]);
}

export default useSeoMetadata;
